export default __webpack_public_path__ + "static/media/greenPoint.73c32e9f.png";